module.exports = __webpack_public_path__ + "static/break-186d4b2bf387ca6e9a8d08304420fbc3.jpg";